import { fetchAuthSession } from 'aws-amplify/auth';
import { checkTrialExpiration } from './CheckTrialExpiration';
import { USER_ROLES_AWS_MAP } from '../constants/userRoles';

export async function refreshSession(options?: any) {
  const session = await fetchAuthSession(options);
  if (!session.tokens) {
    return null;
  }
  // refresh app state
  const userInfo = session.tokens.idToken.payload;
  const userId = userInfo['cognito:username'];
  const userGroup = userInfo['cognito:groups']?.[0];

  if (!(userInfo && userId && userGroup)) {
    throw new Error('Error retrieving user. Please contact it@disgenet.com');
  } else {
    if (userGroup && ![...USER_ROLES_AWS_MAP.keys()].includes(userGroup)) {
      // user is not in any registered userGroup
      throw new Error('User is not in any known userGroup. Please contact it@disgenet.com');
    }
  }
  return session;
}
